import React from 'react';
import { DangerousHTML } from './DangerousHTML';
import { Container } from './Container';

export interface ClaimProps {
  text: string,
}
const Claim: React.FC<ClaimProps> = ({ text }) => (
  <Container>
    <DangerousHTML
      element="section"
      className="claim"
      html={text}
    />
  </Container>
);

export default Claim;
